import { Flex } from "@chakra-ui/layout";
import { useMemo } from "react";
import {
  ManutencaoDto,
  StatusManutencaoEnum,
} from "core/features/manutencao/typings/index";
import TagStatusManutencao from "components/Tags/TagStatusManutencao";
import moment from "moment";
import { ColumnType } from "antd/lib/table";

function useManutencaoColumns({
  useSubtenantsViews,
}: {
  useSubtenantsViews: boolean;
}) {
  return useMemo(() => {
    const columns: ColumnType<ManutencaoDto>[] = [
      {
        title: "Plano de manutenção",
        width: "200px",
        render: (original: ManutencaoDto) => <Flex>{original.nome}</Flex>,
      },
      {
        title: "Data",
        width: "100px",
        render: (original: ManutencaoDto) => (
          <Flex>{moment(original.data).format("DD/MM/YYYY")}</Flex>
        ),
      },
      {
        title: "Periodicidade",
        render: (original: ManutencaoDto) => (
          <Flex>{original.periodicidade}</Flex>
        ),
      },
      {
        title: "Responsável Técnico",
        render: (original: ManutencaoDto) => (
          <Flex>{original.responsavelTecnico.nome}</Flex>
        ),
      },
      {
        title: "Patrimônios",
        render: (original: ManutencaoDto) => (
          <Flex>{original.equipamentos.map((v) => `${v.nome}; `)}</Flex>
        ),
      },
      {
        title: "Status",
        render: (original: ManutencaoDto) => (
          <Flex>
            {original.status.id === StatusManutencaoEnum.Concluida ? (
              <TagStatusManutencao color="green" status="Concluída" />
            ) : original.status.id === StatusManutencaoEnum.Pendente &&
              moment(original.data).isBefore(moment(), "day") ? (
              <TagStatusManutencao color="red" status="Atrasada" />
            ) : original.status.id === StatusManutencaoEnum.Pendente ? (
              <TagStatusManutencao color="orange" status="Pendente" />
            ) : (
              <TagStatusManutencao color="red" status="Não realizada" />
            )}
          </Flex>
        ),
      },
    ];

    if (useSubtenantsViews) {
      columns.push({
        title: "Condomínio",
        width: "150px",
        render: (original: ManutencaoDto) => (
          <Flex>{original.tenant?.nome}</Flex>
        ),
      });
    }

    return columns;
  }, [useSubtenantsViews]);
}

export default useManutencaoColumns;
